import React, { useContext, useState } from "react";

const WidgetsContext = React.createContext({
    widgets: null,
    jsvars: null,
    setWidgets: (data) => {},
    setPreLoadedWidgets: (path, data) => {},
});

export const WidgetsContextProvider = (props) => {
    const [widgets, setWidgets] = useState(null);
    const [jsvars, setJsVars] = useState(null);
    const [preLoadedWidgets, setPreLoadedWidgets] = useState(null);

    const setWidgetsData = (data) => {
        setWidgets(data);
        setPreLoadedWidgets(null);
        setJsVars(data?.find(w => w.name === 'jsvars')?.data?.data);
    };

    const setPreLoadedWidgetsData = (path, data) =>
        setPreLoadedWidgets(
            data == null
                ? null
                : {
                      path: path,
                      data: data,
                  }
        );


    return (
        <WidgetsContext.Provider
            value={{
                widgets: widgets,
                jsvars: jsvars,
                preLoadedWidgets: preLoadedWidgets,
                setWidgets: setWidgetsData,
                setPreLoadedWidgets: setPreLoadedWidgetsData,
            }}
        >
            {props.children}
        </WidgetsContext.Provider>
    );
};

export default WidgetsContext;
